import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { MotionConfig } from 'framer-motion';
import GlobalStyles from './styles/GlobalStyles';
import ScrollManager from './components/ScrollManager';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import SterlingPage from './pages/Sterling';

// One product, one page. The legal and support documents are static HTML in
// public/ and are served by the host directly, so they are deliberately not
// routes here — that also keeps the URLs the Play listing points at stable.
export default function App() {
  return (
    <Router>
      <MotionConfig reducedMotion="user">
        <GlobalStyles />
        <ScrollManager />
        <Navbar />
        <Routes>
          <Route path="/" element={<SterlingPage />} />
          <Route path="*" element={<SterlingPage />} />
        </Routes>
        <Footer />
      </MotionConfig>
    </Router>
  );
}
